/**
 * The default cap for the number of restrictions any user can have for their blocklist
 */
export const DEFAULT_MAXIMUM_BLOCKLIST_RESTRICTIONS = 1500;

/**
 * The default page size for the blocklist table
 */
export const DEFAULT_BLOCKLIST_PAGE_SIZE = 10;
